import { SolvedFieldsRatioLabel } from 'components/common-form/builder/form/node/field/SolvedFieldsRatioLabel';
import { RepriceQuoteButton } from 'components/common-form/sidePanel/actions/quote/RepriceQuoteButton';
import { RepriceQuoteButtonNext } from 'components/common-form/sidePanel/actions/quote/RepriceQuoteButtonNext';
import { ShareButtonNext } from 'components/common-form/sidePanel/docToolbar/summary';
import { FxSpot } from 'components/common-form/sidePanel/status/fxSpotUtils';
import { Price, PricedOn } from 'components/shared/Price/Price';
import { ConnectedTradeWayLiteral, PriceNext, QuoteStatus, QuoteYield, SolveResult } from 'components/shared/PriceNext';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { getFlowWayTranslationKey } from '../cashFlowWayUtils';
import { SolveModeLabel } from '../SolveMode';
import type { QuotedState } from './Quoted.Previously.connect';
import { connectQuotedPreviously } from './Quoted.Previously.connect';

export function QuotedPreviouslyStatus({
  solveResult,
  solveResultFormat,
  solvingMode,
  isMultipleSolvingMode,
  pricedOn,
  children,
  workspaceType,
  flowWay,
  isPriceInconsistentWithForm,
  fxSpot,
  tabId,
  enableReprice = true,
  quoteYield,
}: PropsWithChildren<QuotedState>) {
  const isDynamicWorkspace = workspaceType === 'dynamic';

  if (workspaceType === 'static' || workspaceType === 'dynamic') {
    return (
      <PriceNext
        className="bg-warning text-warning bg-opacity-10"
        tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
        solveMode={
          <SolveModeLabel
            workspaceType={workspaceType}
            solvingMode={solvingMode}
            isMultipleSolvingMode={isMultipleSolvingMode}
          />
        }
        solveResult={
          <SolveResult price={solveResult} priceFormat={solveResultFormat} strike={isPriceInconsistentWithForm} />
        }
        shareButton={!isDynamicWorkspace && <ShareButtonNext className="text-warning" tabId={tabId} />}
        fxSpot={<FxSpot greekLine={fxSpot} isObsolete={isPriceInconsistentWithForm} />}
        solveRatio={<SolvedFieldsRatioLabel className="fw-extrabold align-middle" e2e="solving-fields-ratio" />}
        pricedOn={<PricedOn className="fs-12" pricedOn={pricedOn} />}
        quoteYield={<QuoteYield yieldValue={quoteYield} />}
        quoteStatus={
          <QuoteStatus
            className="alert alert-warning"
            icon="history_toggle_off"
            description="sidePanel.quoteStatus.quoteExpired"
            action={<RepriceQuoteButtonNext tabId={tabId} workspaceType={workspaceType} />}
          />
        }
      />
    );
  }

  return (
    <>
      <Price
        color="warning"
        price={solveResult}
        priceFormat={solveResultFormat}
        fxSpot={fxSpot}
        topLeft={
          <SolveModeLabel
            workspaceType={workspaceType}
            solvingMode={solvingMode}
            isMultipleSolvingMode={isMultipleSolvingMode}
          />
        }
        bottomLeft={flowWay !== 'NoFlowWay' && <FormattedMessage id={getFlowWayTranslationKey(flowWay)} />}
        bottomRight={<PricedOn pricedOn={pricedOn} />}
        strike={isPriceInconsistentWithForm}
        actions={children}
      />
      <div className="alert alert-warning d-flex justify-content-between py-2">
        <span>
          <i className="icon me-2">schedule</i> <FormattedMessage id="sidePanel.quoteExpired" />
        </span>
        {enableReprice && <RepriceQuoteButton tabId={tabId} workspaceType={workspaceType} />}
      </div>
    </>
  );
}

export const QuotedPreviously = connectQuotedPreviously(QuotedPreviouslyStatus);
